import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { applyValue, setNewOptions } from "../../lib";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import { TextSizeMenuContent } from "./TextSizeMenuContent";

interface TextSizeMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function TextSizeMenu({ activeSubMenu, setActiveSubMenu }: TextSizeMenuProps) {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("textSize"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleButtonClick = useCallback(
        (value: number) => {
            const setNewTextSizeOptions = setNewOptions({ name: "textSize", setWidgetMenuOptions });

            function handleClose() {
                setActiveSubMenu(null);
            }

            applyValue({ options, value, setNewOptions: setNewTextSizeOptions, handleClose });
        },
        [options, setWidgetMenuOptions, setActiveSubMenu],
    );

    return (
        <SubMenu activeSubMenu={activeSubMenu}>
            <TextSizeMenuContent onTextSizeButtonClick={handleButtonClick} />
        </SubMenu>
    );
}
